import { IProcedureDetails } from "../../typings/filterEntities";
import { DownloadPDFCallback } from "../ModalDownloadPdf/ModalDownloadPdf";
import ProcedureDetails from "../ProcedureDetails/ProcedureDetails";
import ProcedureDownload from "../ProcedureDownload/ProcedureDownload";
import ProcedureHeader from "../ProcedureHeader/ProcedureHeader";
import styles from "./ProcedureLayout.module.css";

interface IProps {
  procedure: IProcedureDetails;
  onDownload: DownloadPDFCallback;
}

export default function ProcedureLayout({ procedure, onDownload }: IProps) {
  return (
    <article className={styles.root}>
      <ProcedureHeader procedure={procedure} />
      <div className={styles.download}>
        <ProcedureDownload procedure={procedure} onDownload={onDownload} />
      </div>
      <ProcedureDetails procedure={procedure} />
      <footer className={styles.legalese}>
        <p className={styles.legaleseCopy}>
          Please note that any procedure, checklist, or other document available in the MaintainX
          Procedure Hub is provided for general education and information only and does not
          constitute legal, medical, or financial advice. MaintainX makes the materials available AS
          IS and AS PROVIDED, without warranties of any kind. By downloading or using any such
          materials, you assume the risk that they may not be appropriate for your specific
          situation and agree that you are solely responsible for any such use, including compliance
          with applicable law and with meeting any conditions of product warranties.
        </p>
      </footer>
    </article>
  );
}
